import React from "react";
import { SearchIcon } from "../../Icons/Icons";
import InputDefault, { InputDefaultProps } from "./InputDefault";

export type InputFilterDefaultProps = InputDefaultProps;

const InputFilterDefault: React.ForwardRefRenderFunction<
  HTMLInputElement,
  InputFilterDefaultProps
> = ({ ...rest }, ref) => {
  return (
    <InputDefault
      {...rest}
      ref={ref}
      variant="standard"
      containerProps={{ className: "" }}
      inputClasses={"w-full"}
      leftIcon={<SearchIcon />}
    />
  );
};

export default React.forwardRef(InputFilterDefault);
